import { createModule } from 'saga-slice';
import {
  fetchFinancialFramesSagaFactory,
  updateFinancialFrameSagaFactory,
} from './sagas';
import {
  initialState,
  FinancialFramesState,
  FinancialFrame,
  FinancialFrameUpdate,
} from './stateType';

const FinancialFramesSlice = createModule({
  name: 'financialFrames',
  initialState,
  reducers: {
    fetchFinancialFrames: (state: FinancialFramesState) => {
      state.loading = true;
    },
    fetchFinancialFramesSuccess: (
      state: FinancialFramesState,
      payload: FinancialFrame[],
    ) => {
      state.loading = false;
      state.loaded = true;
      state.financialFrames = payload;
    },
    fetchFinancialFramesError: (
      state: FinancialFramesState,
      payload: Error,
    ) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload;
    },
    updateFinancialFrame: (state: FinancialFramesState) => {
      state.updateLoading = true;
    },
    updateFinancialFrameSuccess: (
      state: FinancialFramesState,
      payload: { id: number; body: FinancialFrameUpdate },
    ) => {
      state.updateLoading = false;
      state.financialFrames = state.financialFrames.map((frame) =>
        frame.id === payload.id
          ? {
              ...frame,
              ...payload.body,
              updatedAt: new Date().toISOString(),
            }
          : frame,
      );
    },
    updateFinancialFrameError: (
      state: FinancialFramesState,
      payload: Error,
    ) => {
      state.updateLoading = false;
      state.error = payload;
    },
  },
  sagas: (actions) => ({
    [actions.fetchFinancialFrames]: fetchFinancialFramesSagaFactory(actions),
    [actions.updateFinancialFrame]: updateFinancialFrameSagaFactory(actions),
  }),
});

export default FinancialFramesSlice;
export const financialFramesActions = FinancialFramesSlice.actions;
